import {useMutation} from 'react-query'

import {mutations} from '../../mutations'
import {hubQueryClient} from '../../QueryProvider'

/**
 * Hook to dismiss the order change banner for a specific request.
 *
 * This mutation stores the dismissed requestId in distributeduserstorage,
 * so the banner won't show again for the same requestId.
 */
export const useDismissOrderChangeBanner = () => {
  return useMutation(mutations.dismissOrderChangeBanner, {
    onSuccess: () => {
      // Invalidate the dismissed banners query to update UI
      void hubQueryClient.invalidateQueries('dismissedOrderChangeBanners')
    }
  })
}
